import { render } from "./ViewTk.vue?vue&type=template&id=4703e876"
import script from "./ViewTk.vue?vue&type=script&lang=js"
export * from "./ViewTk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__